import { Box } from '@wds/box';
import React from 'react';
import { t } from '@sm/intl';
import PlatformModule from './components/PlatformModule';
import BrazilLogoWall from './components/BrazilLogoBanner';
import { RebrandV2IntlProps } from '~helpers/types';
import FortuneCallout from '~app/components/FortuneCallout';
import { REBRANDV2_ENDPAGE_COPY } from '~app/pages/SurveyThanks/StandardEndpage/copy';

type Props = {
  calloutItem3: RebrandV2IntlProps;
  utSource: string;
  utSource2: string;
  showIntlEndpage?: boolean;
};

const RebrandIntlEndpage = ({
  calloutItem3,
  utSource,
  utSource2,
  showIntlEndpage = false,
}: Props): React.ReactElement => {
  return (
    <Box>
      <PlatformModule utSource={utSource} {...calloutItem3} />
      {showIntlEndpage && utSource2 !== 'epFormBrazil' ? (
        <FortuneCallout
          showLogoWall
          color="white"
          copy={t(REBRANDV2_ENDPAGE_COPY.REBRANDV2_PRODUCT_CALLOUT_LOGO_HEADING)}
          utSource={utSource}
          utSource2={utSource2}
        />
      ) : (
        <BrazilLogoWall utSource={utSource} {...calloutItem3} />
      )}
    </Box>
  );
};

export default RebrandIntlEndpage;
